export const userFieldBlackList = [
  '_class',
  '_id',
  'username',
  'roles',
  'isOnline',
  'ios_sub',
  'emailConfirmed',
  'timeframeID',
  'note',
  'matches',
  'fullName',
  'hiddenFromMentees',
];
